import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import OfficeService from '../../../Services/OfficeService';
import EditCommissionRateWindowDescription from './EditCommissionRateWindowDescription';
import CommissionRateService from '../../../Services/CommissionRateService';
import CommissionRateItem from '../../../Domain/CommissionRateItem';
import CloseCommissionRateWindowDescription from './CloseCommissionRateWIndowDescription';
import CommissionRateSearchParams from './CommissionRateSearchParams';
import ErrorMessage from '../../../Elements/ErrorMessage';
import CommissionRatesGuideLink from './CommissionRatesGuideLink';

export default class CommissionRatesAdmin extends React.Component {
  static defaultProps = {
    userId: 0,
    officeId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      shownPanel: ShownPanelsEnum.None,
      searchItem: new CommissionRateSearchParams(),
    };

    this.state.searchItem.UserId = props.userId;
    this.state.searchItem.IsOrWillBeActive = false;

    this.refresh = this.refresh.bind(this);
    CommissionRateItem.editFunction = this.editFunction.bind(this);
    CommissionRateItem.closeFunction = this.closeFunction.bind(this);
    this.createFunction = this.createFunction.bind(this);
  }

  refresh(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  createFunction() {
    const selectedItem = new CommissionRateItem();
    selectedItem.UserId = this.props.userId;
    OfficeService.GetOfficeBillingCurrency(this.props.officeId)
      .then((currency) => {
        if (!currency) {
          ErrorMessage.SetErrorMessage('No billing currency found for the office');
          return;
        }
        selectedItem.CurrencyId = currency.currencyId;
        this.setState({
          selectedItem,
          shownPanel: ShownPanelsEnum.AddNewItem,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CRA66', error));
  }

  editFunction(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  closeFunction(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.Close,
    });
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          className={'InnerMenuButtonFigmaList'}
          buttons={[
            {
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              iconName: 'fa-solid fa-plus-circle',
              onClick: this.createFunction,
              tooltip: 'New Commission Rate',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditCommissionRateWindowDescription}
            errorCode='CRA93'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditCommissionRateWindowDescription}
            errorCode='CRA104'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Close,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={CloseCommissionRateWindowDescription}
            errorCode='CRA104'
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <CommissionRatesGuideLink />
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={CommissionRateItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={CommissionRateService.GetListBySearching}
          convertDBItemsFunction={CommissionRateService.ConvertDBItems}
          showSearchStrip={false}
          searchItem={this.state.searchItem}
          orderBy='StartedOn'
          orderDirection='Desc'
          errorCode='CRA146'
        />
      </div>
    );
  }
}
